export default __webpack_public_path__ + "static/media/uhs-logo.29946d31.svg";